/**
 * Payout Mapper
 *
 * Converts raw API response data to the shape the UI expects.
 * When the real API is ready, update the field names here to match
 * the actual response keys without touching any UI components.
 */

export interface PayoutListItem {
  payout_id: string;
  // Property
  property_id: string;
  property_name: string;
  property_city: string;
  platform_name: string;
  // Reservation
  reservation_id: string;
  reservation_code: string;
  guest_name: string;
  reservation_status: string;
  reservation_status_name: string;
  check_in_date: string;
  check_out_date: string;
  // Host Payout
  host_payout: string;
  // Payout Details
  payout_date: string;
  bank_account: string;
  // Payout Breakdown
  payout_breakdown: Array<{
    date: string;
    payment_details: string;
    amount: string;
  }>;
  payout_breakdown_total_payout: string;
  // Payout Amount
  payout_amount: string;
  // Match Status
  payout_match_status: string;
  // Action
  action: string;
  action_name: string;
  notes: string;
  updated_at: string;
  updater_name: string;
}

export const mapPayoutListItem = (raw: any): PayoutListItem => {
  return {
    payout_id: raw.payout_id?.toString() ?? '',
    // Property
    property_id: raw.property_id ?? raw.property?.id ?? '',
    property_name: raw.property_name ?? '-',
    property_city: raw.property_city ?? '-',
    platform_name: raw.reservation_platform ?? '',
    // Reservation
    reservation_id: raw.reservation_id ?? '',
    reservation_code: raw.reservation_code ?? '-',
    guest_name: raw.reservation_guest_name ?? '-',
    reservation_status: raw.reservation_status ?? '',
    reservation_status_name: raw.reservation_status_name ?? '-',
    check_in_date: raw.reservation_check_in_date ?? '-',
    check_out_date: raw.reservation_check_out_date ?? '-',
    // Host Payout
    host_payout: raw.formatted_reservation_revenue?.toString() ?? '-',
    // Payout Details
    payout_date: raw.payout_date ?? '-',
    bank_account: raw.payout_bank_account ?? '-',
    // Payout Breakdown
    payout_breakdown: raw.transactions?.transactions ?? [],
    payout_breakdown_total_payout: raw.transactions?.total_payout ?? '',
    // Payout Amount
    payout_amount: raw.formatted_payout_amount?.toString() ?? '-',
    // Match Status
    payout_match_status: raw.reconciliation_status ?? '',
    // Action
    action: raw.reconciliation_verification?.toLowerCase() ?? '',
    action_name: raw.reconciliation_verification_name ?? '-',
    notes: raw.reconciliation_notes ?? '',
    updated_at: raw.updated_at ?? '-',
    updater_name: raw.updater?.name ?? '-',
  };
};

export const mapPayoutList = (response: any): { records: PayoutListItem[]; total: number; kpis: { matched: string; unmatched: string; ratio: string } } => {
  return {
    records: (response?.records || []).map(mapPayoutListItem),
    total: response?.total_records || 0,
    kpis: {
      matched: response?.matched_amount ?? '0.00',
      unmatched: response?.unmatched_amount ?? '0.00',
      ratio: response?.match_ratio?.toString() ?? '0',
    }
  };
};
